/**
 * ASW-2 — student lifecycle presentation helpers.
 * Continuity vocabulary + live status hierarchy. Consumes existing derive/chrome —
 * does not invent FLOW_STATE / L1 transitions.
 */

import { EXT_CONNECTIVITY } from './assessmentExperienceDerive';

/** Shared CTA / caption vocabulary across intro → live → complete → results. */
export const LIFECYCLE_CTA = Object.freeze({
  START: 'Start assessment',
  CONTINUE: 'Continue assessment',
  VIEW_SUMMARY: 'View summary',
  VIEW_RESULTS: 'View results',
  WAITING_WINDOW: 'Waiting for window',
  FINISH: 'Finish assessment',
  BACK_TO_SUMMARY: 'Back to summary',
  RETURN_TO_LIST: 'Return to assessments',
});

export function resultsUnlockCaption() {
  return 'Results pending faculty release.';
}

/**
 * Body connection card — suppress when chrome strip + stale notice already tell the story.
 * Keep "Connection restored" and optional guided heartbeat detail.
 */
export function shouldRenderLiveConnectionCard({
  pollOk = true,
  previouslyInterrupted = false,
  extensionConnectivity = null,
  lastHeartbeatAt = null,
} = {}) {
  if (!pollOk) return false;
  if (previouslyInterrupted) return true;

  if (
    extensionConnectivity === EXT_CONNECTIVITY.EXT_DEGRADED ||
    extensionConnectivity === EXT_CONNECTIVITY.EXT_UNKNOWN
  ) {
    return false;
  }

  if (extensionConnectivity === EXT_CONNECTIVITY.EXT_GUIDED) {
    return Boolean(lastHeartbeatAt);
  }

  // Legacy path without EXT_* axis — keep prior connectionPresentation behaviour.
  return true;
}

/** State banner — skip phases owned by chrome strip / stale notice. */
export function shouldRenderLiveStateBanner(phase) {
  if (!phase || phase === 'active' || phase === 'connection_loss') return false;
  return true;
}
